import React, { useMemo, useState } from "react";
import OurApproach from "./IntroTabs.jsx/OurApproach";
import CsrPolicy from "./IntroTabs.jsx/CsrPolicy";
import CsrActivities from "./IntroTabs.jsx/CsrActivities";
import Expense from "./IntroTabs.jsx/Expense";
import { filterById, getLatestDateFromData } from "../../../Utils/utils";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import Loader from "../../../components/Loader";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import NeepcoCSRCommunity from "./IntroTabs.jsx/NeepcoCSRCommunity";

const IntroductionCSR = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: introductionData = [], isLoading: introductionIsLoading } =
    useGetProtectedApiDataQuery({ url: "introduction", lang: languageType });

  // last updated on
  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(introductionData);
  }, [introductionData]);

  const [csrTabStr, setCsrTabStr] = useState("our-approach");
  const ourApproachData = filterById(introductionData, "782");
  const data2 = filterById(introductionData, "783");
  const csrPolicy = filterById(introductionData, "784");
  const csrActivities = filterById(introductionData, "785");
  const expenses = filterById(introductionData, "786");
  const NeepcoCommunity = filterById(introductionData, "35159");

  if (introductionIsLoading) {
    return (
      <div className="csr-loader">
        <Loader />;
      </div>
    );
  }

  return (
    <>
      <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

      <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
        <ul className="nav nav-pills inner-customtab">
          <li className="nav-item">
            <a
              className={`nav-link ${
                csrTabStr === "our-approach" ? "active" : ""
              }`}
              data-bs-toggle="pill"
              href="#hydro"
              onClick={() => setCsrTabStr("our-approach")}
            >
              {getText("Our Approach", "हमारा दृष्टिकोण")}
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                csrTabStr === "csr-policy" ? "active" : ""
              }`}
              data-bs-toggle="pill"
              href="#hydro"
              onClick={() => setCsrTabStr("csr-policy")}
            >
              {getText("NEEPCO CSR Policy", "नीपको सीएसआर नीति")}
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                csrTabStr === "csr-activities" ? "active" : ""
              }`}
              data-bs-toggle="pill"
              href="#hydro"
              onClick={() => setCsrTabStr("csr-activities")}
            >
              {getText("NEEPCO CSR Activities", "नीपको सीएसआर गतिविधियाँ")}
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                csrTabStr === "neepco-community" ? "active" : ""
              }`}
              data-bs-toggle="pill"
              href="#hydro"
              onClick={() => setCsrTabStr("neepco-community")}
            >
              {getText(
                "NEEPCO Community Development Policy",
                "नीपको सामुदायिक विकास नीति"
              )}
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${csrTabStr === "expense" ? "active" : ""}`}
              data-bs-toggle="pill"
              href="#hydro"
              onClick={() => setCsrTabStr("expense")}
            >
              {getText("Expenditure", "व्यय")}
            </a>
          </li>
        </ul>
        <div className="tab-content">
          {csrTabStr === "our-approach" && (
            <OurApproach data={ourApproachData} data2={data2} />
          )}
          {csrTabStr === "csr-policy" && <CsrPolicy data={csrPolicy} />}
          {csrTabStr === "csr-activities" && (
            <CsrActivities data={csrActivities} />
          )}
          {csrTabStr === "expense" && <Expense data={expenses} />}
          {csrTabStr === "neepco-community" && (
            <NeepcoCSRCommunity data={NeepcoCommunity} />
          )}
        </div>
      </div>
    </>
  );
};

export default IntroductionCSR;
